import React, { useEffect, useState, useRef } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import style from "./profile.module.scss";
import { FormInputControl } from "../common";
import LoginService from "../../../service/Auth/Login";
import ProfileService from "../../../service/profile";
import { useHistory } from "react-router-dom";
import { PasswordValidation } from "../../hook/passwordValidation";
import { usePopperTooltip } from "react-popper-tooltip";
import { animated, useTransition } from "react-spring";
import VerifyKyc from "./VerifyKyc";
import ReCAPTCHA from "react-google-recaptcha";
import SMSSubscription from "./SMSSubscription";

function ChangePassword({ policy, ...props }) {
  console.log("changepassworddd", props);
  console.log(policy, "policy goes here ");
  const [controlledVisible, setControlledVisible] = useState(false);
  const { t } = useTranslation();
  const [password, setPassword] = useState({
    password: "",
    policy: "",
  });
  const { getArrowProps, getTooltipProps, setTooltipRef, setTriggerRef } =
    usePopperTooltip({
      visible: controlledVisible,
      onVisibleChange: setControlledVisible,
      trigger: "focus",
    });
  const transitions = useTransition(controlledVisible, null, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  });
  const [validLength, hasNumber, upperCase, lowerCase, specialChar, mixedcase] =
    PasswordValidation({
      password: password.password,
      policy: policy,
    });
  const [passwordPolicy, setPasswordPolicy] = useState({
    uppercase: upperCase,
    lowercase: lowerCase,
    sp_char: specialChar,
    number: hasNumber,
    min_length: validLength,
    mixedcase: mixedcase,
  });

  const recaptchaRef = useRef(null);
  useEffect(() => {
    setPasswordPolicy({
      uppercase: upperCase,
      lowercase: lowerCase,
      sp_char: specialChar,
      number: hasNumber,
      min_length: validLength,
      mixedcase: mixedcase,
    });
  }, [validLength, hasNumber, upperCase, lowerCase, specialChar, mixedcase]);
  const InitalData = [
    { key: "currentPassword", field: "current_password" },
    { key: "newPassword", field: "new_password" },
    { key: "confirmPassword", field: "password_confirmation" },
  ].map((items) => {
    return {
      code: items.key,
      form_field: items.field,
      value: "",
      type: "password",
      error: {
        field: "",
        error: "",
      },
    };
  });
  //captcha data
  const CaptchaData = {
    code: "captcha",
    value: "",
    type: "text",
    error: {
      field: "",
      error: "",
    },
  };
  const history = useHistory();
  const [state, setState] = useState({
    passwordData: InitalData,
    captcha: CaptchaData,
    captchaImage: "",
    propsData: {
      label: "",
      icon: "",
      subtittle: "",
      buttonSubmit: "",
      fadeClass: true,
    },
  });

  const changehandler = (e, key = "") => {
    const { name, value } = e.target;
    const { passwordData, captcha } = state;

    if (key === "captcha") {
      captcha.value = value;
      captcha.error = {
        error: "",
        field: "",
      };
      setState((prev) => ({
        ...prev,
        captcha: captcha,
      }));
    } else {
      if (name === "newPassword") {
        const updatedPassword = {
          ...password,
          password: value,
          policy: policy,
        };

        const hasMixedCase =
          policy.mixedcase === 1
            ? /[a-z]/.test(value) && /[A-Z]/.test(value)
            : true;
        const hasSpecialChar =
          policy.sp_char === 1 ? /[!@#$%^&*(),.?":{}|<>]/.test(value) : true;
        const hasNumber = policy.number === 1 ? /[0-9]/.test(value) : true;
        const hasValidLength = value.length >= policy.min_length;

        const isValidPassword =
          hasMixedCase && hasSpecialChar && hasNumber && hasValidLength;

        setPassword({
          ...updatedPassword,
          policy: {
            ...updatedPassword.policy,
            mixedcase: hasMixedCase,
            sp_char: hasSpecialChar,
            number: hasNumber,
            min_length: hasValidLength,
          },
        });

        setState((prev) => ({
          ...prev,
          passwordData: prev.passwordData.map((field) => {
            if (field.code === "newPassword") {
              return {
                ...field,
                error: isValidPassword
                  ? { field: "", error: "" }
                  : { field: field.code, error: "validation.required" },
              };
            }
            return field;
          }),
        }));
      }

      const updatedPasswordData = passwordData.map((field) => {
        if (field.code === name) {
          return {
            ...field,
            value: value,
            error: {
              error: "",
              field: "",
            },
          };
        }
        return field;
      });

      setState((prev) => ({
        ...prev,
        passwordData: updatedPasswordData,
      }));
    }
  };

  useEffect(() => {
    setState((prev) => ({
      ...prev,
      propsData: {
        label: props.modalType,
        icon: props.icon,
        subtittle: "youCanResetYourPassword",
        buttonSubmit: "changepassowrd",
      },
    }));
  }, [props.modalType, props.icon]);
  //onsubmit form
  const onSubmit = async (e) => {
    e.preventDefault();
    const service = new LoginService();
    const { passwordData, propsData, captcha } = state;

    if (propsData.label === "forgotTransactionPassword" && !captcha.value) {
      // If it's a "forgotTransactionPassword" scenario and captcha is not provided
      const captchaError = {
        field: "captcha",
        error: "validation.required",
      };
      setState((prev) => ({
        ...prev,
        captcha: {
          ...prev.captcha,
          error: captchaError,
        },
      }));
      props.setNotify("danger", t("Common.error"), t(captchaError.error));
      return;
    }

    let isValid = true;
    let currentPassword = "";
    let formData = {};
    console.log("=== inside on submit function === ", policy.disableHelper);
    passwordData.forEach((field) => {
      if (!field.value) {
        isValid = false;
        field.error = {
          field: field.code,
          error: "validation.required",
        };
      } else if (field.code === "newPassword") {
        if (policy.disableHelper) {
          const minLength = policy.disableHelper
            ? policy.min_length
            : propsData.label === "changePassword"
            ? policy.min_length
            : policy.min_length;
          if (field.value.length < minLength) {
            isValid = false;
            field.error = {
              field: field.code,
              error: "validation.min_length",
              length: minLength,
            };
          } else if (field.value.length > 32) {
            isValid = false;
            field.error = {
              field: field.code,
              error: "validation.max_length",
              length: 32,
            };
          }
        }
        currentPassword = field.value;
      } else if (
        field.code === "confirmPassword" &&
        currentPassword !== field.value
      ) {
        isValid = false;
        field.error = {
          field: field.code,
          error: "validation.mismatch",
        };
      }
      formData[field.form_field] = field.value;
    });

    if (isValid) {
      try {
        let res;
        if (propsData.label === "changePassword") {
          res = await service.ChangePasword(formData);
        } else if (propsData.label === "changeTransactionPassword") {
          res = await service.ChangeTransactionPassword(formData);
        } else if (propsData.label === "forgotTransactionPassword") {
          const requestData = {
            captcha: captcha.value,
          };
          res = await service.forgotTransactionPassword(requestData);
        }

        if (res.status) {
          props.setNotify(
            "success",
            t("Common.success"),
            t(
              propsData.label === "forgotTransactionPassword"
                ? "validation.captchaSuccess"
                : "profile.passwordUpdatedSuccessfully"
            )
          );
          setState((prev) => ({
            ...prev,
            passwordData: InitalData,
          }));
        } else {
          if (res.error.code === 1021 || res.error.code === 1002) {
            props.setNotify(
              "danger",
              t("Common.error"),
              t("validation.incorrectPassword")
            );
          } else if (res.error.code === 1070) {
            props.setNotify("danger", t("Common.error"), res.error.description);
          } else if (res.error.code === 1004) {
            props.setNotify(
              "danger",
              t("Common.error"),
              t("validation.invalidCaptcha")
            );
          } else if (res.error.code === 1002) {
            history.push("/logout");
          } else {
            props.setNotify("danger", t("Common.error"), res.error.description);
          }
        }
      } catch (error) {
        // Handle any error during the API call
        console.error(error);
        props.setNotify(
          "danger",
          t("Common.error"),
          t("validation.checkValueYouHaveSubmitted")
        );
      }
    } else {
      setState((prev) => ({
        ...prev,
        passwordData: [...passwordData],
      }));
      props.setNotify(
        "danger",
        t("Common.error"),
        t("validation.checkValueYouHaveSubmitted")
      );
    }
  };

  //forgot button click
  const clickForgot = () => {
    //   reloadCaptcha()
    setState((prev) => ({
      ...prev,
      propsData: {
        label: "forgotTransactionPassword",
        icon: "fa fa-envelope-open",
        subtittle: "noteSendConfirmationMailFollowThatInstruction",
        buttonSubmit: "requestSend",
      },
    }));
  };
  //reloadCaptcha
  const reloadCaptcha = () => {
    const captchaservice = new ProfileService();
    captchaservice.getCaptcha().then((res) => {
      let outside = URL.createObjectURL(res);
      setState((prev) => ({
        ...prev,
        captchaImage: outside,
      }));
    });
  };
  //captcha submit
  const onCaptchaChange = (value) => {
    const { captcha } = state;
    if (value) {
      captcha.value = value;
      captcha.error = {
        error: "",
        field: "",
      };
      setState((prev) => ({
        ...prev,
        captcha: captcha,
      }));
    }
  };

  //onClose modal
  const closeModal = () => {
    setState((prev) => ({
      ...prev,
      passwordData: InitalData,
      propsData: {
        ...prev,
        fadeClass: false,
      },
    }));
    props.onClose();
  };

  const onBlurHandler = (e, key) => {
    if (key === "newPassword") {
      const { disableHelper, ...passwordRequirements } = policy;
      const failedRequirements = [];
      let isValidPassword = true;
      console.log("passwordRequirements", passwordRequirements, disableHelper);
      if (disableHelper) {
        for (const requirement in passwordRequirements) {
          if (passwordRequirements[requirement] === 0) {
            continue; // Skip requirements with value 0
          }

          if (!passwordPolicy[requirement]) {
            failedRequirements.push(requirement);
          }
        }

        isValidPassword = failedRequirements.length === 0;
      }

      const NewData = state.passwordData.map((items) => {
        if (items.code === "newPassword") {
          if (!isValidPassword) {
            return {
              ...items,
              error: {
                error: "validation.passwordPolicyInvalid",
                failedRequirements,
              },
            };
          }
        }
        return items;
      });

      setState((prev) => ({
        ...prev,
        passwordData: NewData,
      }));
    }
  };

  return (
    <>
      {props.modalType === "verifyYourAccount" ? (
        <Modal
          show={props.show}
          backdropClassName={`modalBackDrops`}
          contentClassName={style.ModalContent}
          onHide={() => {}}
          dialogClassName={`animate__animated ${
            !state.propsData.fadeClass
              ? "animate__fadeInDown"
              : "animate__fadeInUp"
          }`}
        >
          <Modal.Header className={style.ModalHeader}></Modal.Header>
          <Modal.Body>
            <VerifyKyc {...props} />
          </Modal.Body>
        </Modal>
      ) : props.modalType === "manageSubscription" ? (
        <Modal
          show={props.show}
          backdropClassName={`modalBackDrops`}
          contentClassName={style.ModalContent}
          onHide={() => {}}
          dialogClassName={`animate__animated ${
            !state.propsData.fadeClass
              ? "animate__fadeInDown"
              : "animate__fadeInUp"
          }`}
        >
          {/* <Modal.Header className={style.ModalHeader}></Modal.Header> */}
          <Modal.Body>
            <SMSSubscription {...props} />
          </Modal.Body>
        </Modal>
      ) : (
        <Modal
          show={props.show}
          backdropClassName={`modalBackDrops`}
          contentClassName={style.ModalContent}
          onHide={() => {}}
          dialogClassName={`animate__animated ${
            !state.propsData.fadeClass
              ? "animate__fadeInDown"
              : "animate__fadeInUp"
          }`}
        >
          <Modal.Header className={style.ModalHeader}></Modal.Header>
          <Modal.Body className={style.ModalBody}>
            <h2 className={style.modalHeading}>
              {t(`Common.${state.propsData.label}`)}?
            </h2>
            <Form onSubmit={onSubmit} noValidate>
              {state.propsData.label !== "forgotTransactionPassword" ? (
                state.passwordData.map((field, index) => {
                  return (
                    <FormInputControl
                      key={index}
                      label={t(`profile.${field.code}`)}
                      error={field.error}
                      required={true}
                      inputProps={{
                        ref:
                          field.code === "newPassword" && policy.disableHelper
                            ? setTriggerRef
                            : null,
                        type: field.type,
                        name: field.code,
                        value: field.value,
                        onChange: changehandler,
                        onBlur: (e) => {
                          onBlurHandler(e, field.code);
                        },
                      }}
                    >
                      {
                        // password policy
                        field.code === "newPassword" &&
                          policy.disableHelper &&
                          transitions.map(
                            ({ item, key, props }) =>
                              item && (
                                <animated.div
                                  key={key}
                                  ref={setTooltipRef}
                                  {...getTooltipProps({
                                    className: "tooltip-container",
                                    style: props,
                                  })}
                                >
                                  <div>
                                    {policy.mixedcase === 1 && (
                                      <p>
                                        {passwordPolicy.mixedcase ? (
                                          <i
                                            className="fa fa-check-circle"
                                            style={{ color: "green" }}
                                          ></i>
                                        ) : (
                                          <i
                                            className="fa fa-times-circle"
                                            style={{ color: "#f05050" }}
                                          ></i>
                                        )}
                                        {t("validation.atleast_mixedcase")}
                                      </p>
                                    )}
                                    {policy.number === 1 && (
                                      <p>
                                        {passwordPolicy.number ? (
                                          <i
                                            className="fa fa-check-circle"
                                            style={{ color: "green" }}
                                          ></i>
                                        ) : (
                                          <i
                                            className="fa fa-times-circle"
                                            style={{ color: "#f05050" }}
                                          ></i>
                                        )}
                                        {t("validation.atleast_number")}
                                      </p>
                                    )}
                                    {policy.sp_char === 1 && (
                                      <p>
                                        {passwordPolicy.sp_char ? (
                                          <i
                                            className="fa fa-check-circle"
                                            style={{ color: "green" }}
                                          ></i>
                                        ) : (
                                          <i
                                            className="fa fa-times-circle"
                                            style={{ color: "#f05050" }}
                                          ></i>
                                        )}
                                        {t("validation.atleast_sp_char")}
                                      </p>
                                    )}
                                    <p>
                                      {passwordPolicy.min_length ? (
                                        <i
                                          className="fa fa-check-circle"
                                          style={{ color: "green" }}
                                        ></i>
                                      ) : (
                                        <i
                                          className="fa fa-times-circle"
                                          style={{ color: "#f05050" }}
                                        ></i>
                                      )}
                                      {t("validation.atleast_min_length", {
                                        count: policy.min_length,
                                      })}
                                    </p>
                                  </div>
                                  <div
                                    {...getArrowProps({
                                      className: "tooltip-arrow",
                                    })}
                                  />
                                </animated.div>
                              )
                          )
                      }
                    </FormInputControl>
                  );
                })
              ) : (
                <React.Fragment>
                  <Form.Group className={style.captcha}>
                    <ReCAPTCHA
                      ref={recaptchaRef}
                      sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                      onChange={onCaptchaChange}
                    />
                  </Form.Group>
                </React.Fragment>
              )}

              <div className={style.actionButton}>
                <Button
                  variant="secondary"
                  onClick={closeModal}
                  className={style.cancelButton}
                >
                  {t("Button.cancel")}
                </Button>
                <Button type="submit" className={style.changeButton}>
                  {t("Button." + state.propsData.buttonSubmit)}
                </Button>
              </div>

              {state.propsData.label === "changeTransactionPassword" && (
                <div className={style.forgotTag} onClick={clickForgot}>
                  {t("profile.forgotTransactionPassword")}
                </div>
              )}
            </Form>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
}

export default ChangePassword;
